var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 6447",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 963",
    d: "M17.148 14.8L11.056 4.234a1.219 1.219 0 00-2.111 0L2.852 14.8a1.219 1.219 0 001.056 1.825h12.184a1.219 1.219 0 001.056-1.825zM10 12.613a1.168 1.168 0 011.168 1.168A1.168 1.168 0 0110 14.949a1.168 1.168 0 01-1.168-1.168A1.168 1.168 0 0110 12.613zm-1.109-4.2a.3.3 0 01.3-.321H10.8a.3.3 0 01.3.321l-.179 3.455a.3.3 0 01-.3.288H9.384a.3.3 0 01-.3-.288z"
  })));
}
export default SvgWarning;